import axios from '../axios'

export const selectByPage = (data) => {
    return axios({
        url: '/admin/protocol/selectByPage',
        method: 'post',
        data
    })
}

export const insert = (data) => {
    return axios({
        url: '/admin/protocol/insert',
        method: 'post',
        data
    })
}

export const update = (data) => {
    return axios({
        url: '/admin/protocol/update',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/admin/protocol/batchDelete',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/protocol.js